// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1qk7T","title":"Section_title__35KLv"};